export const TimeLogActivities = {
    CONSTRUCTION: 1,
    R_AND_D: 2,
    GENERAL: 3,
    DESIGN: 4,
    LEAVE: 5,
    MEETING: 6,
    RELEASE: 7,
    ACCOUNT: 8,
    SALES: 9,
    DATABASE_UPDATION: 10,
    SESSION: 11,
    SEO: 12,
};
